import { isUndefinedNullOrEmpty } from '../utils';
export default (defaultState) => ((state) => (isUndefinedNullOrEmpty(state) === true ? defaultState : state));


// WEBPACK FOOTER //
// ./src/js/reducers/noOpReducerCreator.js